module.exports = __webpack_public_path__ + "static/best-est-roi-winter-2eb468e5864e344394a3d9ab3aee28f4.svg";